"use client";

import Breadcrumbs from "@/components/entities/breadcrumbs";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import clsx from "clsx";
import { useTranslations } from "next-intl";

const PrivacyContent = () => {
  const t = useTranslations();

  const breadcrumbs = [
    { title: t("home"), url: "/" },
    { title: t("privacyPolicy"), url: "/privacy" },
  ];

  return (
    <Container className={S.wrapper}>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <h1 className={S.title}>{t("privacy.privacyPolicy")}</h1>
      <div className={S.infoWrapper}>
        <div className={clsx(S.paragraph, S["paragraph--level-0"])}>
          <h3 className={S.subtitle}>{t("privacy.responsibleParty")}</h3>
          <p className={S.text}>{t("privacy.responsiblePartyText")}</p>
          <p className={S.upperText}>{t("privacy.contactInfo")}</p>
          <p className={S.text}>{t("privacy.companyAddress")}</p>
          <p className={S.text}>{t("privacy.policyUpdateNotice")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-1"])}>
          <h3 className={S.subtitle}>{t("privacy.scopeTitle")}</h3>
          <p className={S.text}>{t("privacy.personalDataDefinition")}</p>
          <p className={S.text}>{t("privacy.collectedDataTypes")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-1"])}>
          <h3 className={S.subtitle}>{t("privacy.sensitiveDataTitle")}</h3>
          <p className={S.text}>{t("privacy.childrenNotice")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-1"])}>
          <h3 className={S.subtitle}>{t("privacy.collectionMethodTitle")}</h3>
          <p className={S.text}>{t("privacy.activeCollectionText")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-1"])}>
          <h3 className={S.subtitle}>{t("privacy.contractProcessingTitle")}</h3>
          <p className={S.text}>{t("privacy.contractDataText")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-1"])}>
          <h3 className={S.subtitle}>{t("privacy.shippingTitle")}</h3>
          <p className={S.text}>{t("privacy.shippingText")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-1"])}>
          <h3 className={S.subtitle}>{t("privacy.contactAndRightsTitle")}</h3>
          <p className={S.text}>{t("privacy.contactAndRightsText")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-2"])}>
          <h3 className={S.subtitle}>{t("privacy.yourRightsTitle")}</h3>
          <p className={S.text}>{t("privacy.rightsIntro")}</p>

          <ul className={clsx(S.list, S["list--level-0"])}>
            <li className={S.listItem}>{t("privacy.rightToAccess")}</li>
            <li className={S.listItem}>{t("privacy.rightToRectification")}</li>
            <li className={S.listItem}>
              {t("privacy.rightToErasure")}
              <ul className={clsx(S.list, S["list--level-1"])}>
                {t.raw("privacy.erasureExceptions").map((text: string, i: number) => (
                  <li key={i} className={S.listItem}>
                    {text}
                  </li>
                ))}
              </ul>
            </li>
            <li className={S.listItem}>
              {t("privacy.rightToRestriction")}
              <ul className={clsx(S.list, S["list--level-1"])}>
                {t.raw("privacy.restrictionConditions").map((text: string, i: number) => (
                  <li key={i} className={S.listItem}>
                    {text}
                  </li>
                ))}
              </ul>
            </li>
            <li className={S.listItem}>{t("privacy.rightToDataPortability")}</li>
            <li className={S.listItem}>{t("privacy.rightToLodgeComplaint")}</li>
          </ul>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-2"])}>
          <h3 className={S.subtitle}>{t("privacy.objectionTitle")}</h3>
          <p className={S.text}>{t("privacy.objectionGeneral")}</p>
          <p className={S.text}>{t("privacy.objectionConsequence")}</p>
          <p className={S.text}>{t("privacy.objectionMarketing")}</p>
        </div>

        <div className={clsx(S.paragraph, S["paragraph--level-2"])}>
          <h3 className={S.subtitle}>{t("privacy.contactOptionsTitle")}</h3>
          <p className={S.text}>{t("privacy.contactOptionsText")}</p>
        </div>
      </div>
    </Container>
  );
};

export default PrivacyContent;
